import { LinearProgress as MLinearProgress, LinearProgressProps } from '@mui/material'

export const LinearProgress: React.FC<LinearProgressProps> = (props) => {
  return <MLinearProgress {...props} />
}
